<template>
  <div
    id="content"
    class="content"
    style="margin-left:0px;"
  >
    <h1
      class="page-header"
      style="text-align:left"
    >
      订单管理
      <small>/&nbsp;订单列表</small>
    </h1>

    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">订单列表</h4>
              </div>
              <!-- end panel-heading -->
              <!-- begin panel-body -->
              <div class="panel-body">
                <form style="margin-top:16px;padding-left:15px;">
                  <fieldset>
                    <div class="form-group row m-b-15">
                      <label class="col-md-1 col-form-label">订单编号</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="订单编号"
                          v-model="orderNo"
                        >
                      </div>
                      <label class="col-md-1 col-form-label">相关渠道</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="渠道号 / 渠道名称"
                          v-model="fuzzyRecom"
                        >
                      </div>
                      <label class="col-md-1 col-form-label">订单时间</label>
                      <div class="col-md-3">
                        <el-date-picker
                          style="width:100%;height:34px;"
                          v-model="TimeValue"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="ChangePicker"
                        ></el-date-picker>
                      </div>
                      <div class="col-md-2"></div>
                      <label class="col-md-1 col-form-label LineSpacing">订单状态</label>
                      <div
                        class="col-md-2 LineSpacing"
                        style="position:relative"
                        @mouseenter="EnterSelect"
                        @mouseleave="LeaveSelect"
                      >
                        <img
                          src="@/assets/Close.svg"
                          style="position:absolute;width:20px;top:7px;right:30px;"
                          v-if="CloseShow"
                          @click="ClearSelect"
                        >
                        <select
                          class="form-control"
                          v-model="orderStatus"
                        >
                          <option style="display:none">请选择</option>
                          <option value="0">取消订单</option>
                          <option value="1">购物车</option>
                          <option value="2">已提交，未支付</option>
                          <option value="3">已支付</option>
                          <option value="4">拦截</option>
                          <option value="5">审核放行，流转到中台</option>
                          <option value="6">已发货</option>
                          <option value="7">已收货</option>
                          <option value="8">交易成功</option>
                          <option value="9">售后</option>
                          <option value="10">退货</option>
                          <option value="11">退款</option>
                          <option value="12">换货</option>
                          <option value="13">交易关闭</option>
                        </select>
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing">订单来源</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="orderFrom"
                          clearable
                          placeholder="请选择"
                          style="width:100%;font-size:12px;"
                          @change="selectOrder"
                        >
                          <el-option
                            v-for="item in orderFromList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing" v-if="isO2O">门店名称</label>
                      <div class="col-md-2 LineSpacing" v-if="isO2O">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="门店名称"
                          v-model="shopName"
                        >
                      </div>
                      <div class="col-md-1 LineSpacing">
                        <a
                          class="btn btn-primary ButtonColor m-r-5"
                          @click="SearchClick()"
                        >查询</a>
                      </div>
                    </div>
                    <div style="margin-bottom:15px;text-align:right;">
                      <a
                        class="btn btn-primary ButtonColor m-r-5"
                        @click="ExportClick()"
                      >导出</a>
                      <!-- <a
                        class="btn btn-warning ButtonColor"
                        style="margin-right:16px;"
                        @click="CancelOrder()"
                      >取消订单</a> -->
                    </div>
                  </fieldset>
                </form>

                <el-table
                  :data="UserManagementList"
                  border
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column prop="ordernumber" label="序号" width="60" align="center"></el-table-column>
                  <el-table-column prop="orderNo" label="订单编号" align="center" width="180" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="recom" label="渠道号" align="center" width="150" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="recomName" label="渠道名称" align="center" width="180" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="shopName" label="门店名称" align="center" width="200" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="goodsName" label="商品名称" align="center" width="300" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="orderStatusName" label="订单状态" align="center" width="150" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="payVoucher" label="支付流水号" align="center" width="250" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="buyerName" label="订购人" align="center" width="100" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="buyerTel" label="联系方式"  align="center"  width="120" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="buyertime" label="下单时间" align="center" width="180" show-overflow-tooltip></el-table-column>
                  <!-- <el-table-column label="支付申报" align="center" width="100">
                    <template slot-scope="scope">
                      <button
                        class="btn btn-primary btn-sm ButtonColor"
                        @click="DeclareClick(scope.row)"
                        :disabled="scope.row.declaredisabled"
                      >支付申报</button>
                    </template>
                  </el-table-column> -->
                  <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                      <a
                        class="btn btn-primary btn-sm ButtonColor"
                        data-toggle="modal"
                        @click="DetailClick(scope.row)"
                      >详情</a>

                      
                    </template>
                  </el-table-column>
                </el-table>
                <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <el-dialog
      title
      :visible.sync="outerVisible"
      width="500px"
    >
      <div
        v-if="EditDialog === 2"
        class="ModelPadding"
      >
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">确定取消吗?</div>
          <div class="swal-footer">
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSure"
            >确定</div>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="MakeCancel"
            >取消</div>
          </div>
        </div>
      </div>
      <div
        v-if="EditDialog === 3"
        class="ModelPadding"
      >
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">确定支付申报吗?</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit('ruleForm')"
              :disabled="disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
export default {
  name: "OrderList",
  data() {
    return {
      value1: "",
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      orderNo: "",
      bagNo: "",
      startTime: "",
      endTime: "",
      orderStatus: "3",
      shopName:"",
      outerVisible: false,
      inputdisabled: true,
      DialogTitle: "编辑",
      EditDialog: 1,
      outerWidth: "500px",
      orderFrom: "请选择",
      CurrentSelection: [],
      options: [],
      CloseShow: false,
      CloseShows: false,
      BrandOptions: [],
      brand: "",
      ruleForm: {},
      rules: {},
      RecomList: [],
      fuzzyRecom: "",
      TimeValue: "",
      disabled: false,
      UserManagementList: [],
      DeclareList: [],
      multipleSelection: [],
      cancelShow: false,
      cancelone: false,
      orderFromList: [
        {
          label: "PC商城",
          value: "20"
        },
        {
          label: "O2O门店",
          value: "21"
        }
      ],
      isO2O:false
    };
  },
  watch: {
    pageNo: {
      handler(newName, oldName) {
        if (this.$route.params && this.$route.params.pageNo) {
          this.pageNo = this.$route.params.pageNo;
        }
      },
      immediate: true
    },
    pagesize: {
      handler(newName, oldName) {
        if (this.$route.params && this.$route.params.pagesize) {
          this.pageSize = this.$route.params.pagesize;
        }
      },
      immediate: true
    }
  },
  computed: {
    pageNo: {
      set(val) {
        if (val) {
          this.pageindex = val;
        }
      },
      get() {
        //console.log('我被调用了') //msg1获取值时触发
      }
    },
    pagesize: {
      set(val) {
        if (val) {
          this.pageSize = val;
        }
      },
      get() {
        //console.log('我被调用了') //msg1获取值时触发
      }
    }
  },
  mounted: function() {
    if (this.$route.params && this.$route.params.searchContent) {
      this.orderNo = this.$route.params.searchContent.orderNo;
      this.fuzzyRecom = this.$route.params.searchContent.fuzzyRecom;

      if (
        this.$route.params.searchContent.TimeValue !== null &&
        this.$route.params.searchContent.TimeValue !== ""
      ) {
        this.startTime = this.FormatAllDate(
          this.$route.params.searchContent.TimeValue[0]
        );
        this.endTime = this.FormatAllDate(
          this.$route.params.searchContent.TimeValue[1]
        );
      } else {
        this.startTime = "";
        this.endTime = "";
      }

      this.TimeValue = this.$route.params.searchContent.TimeValue;
      this.orderStatus = this.$route.params.searchContent.orderStatus;
      this.orderFrom = this.$route.params.searchContent.orderFrom;
    }
    this.initdata();
  },
  methods: {
    CancelOrder() {
      if (this.multipleSelection.length === 0) {
        this.$notify({
          title: "失败",
          message: "请选择一条数据",
          type: "error"
        });
      } else {
        this.multipleSelection.forEach(element => {
          if (
            element.orderStatus !== 1 &&
            element.orderStatus !== 2 &&
            element.orderStatus !== 3 &&
            element.orderStatus !== 4
          ) {
            this.cancelShow = true;
          }
        });

        if (this.cancelShow) {
          this.$notify({
            title: "失败",
            message: "请选择正确的数据",
            type: "error"
          });
        } else {
          this.outerVisible = true;
          this.EditDialog = 2;
        }
      }
    },
    CancelClick(row) {
      this.CurrentSelection = row;

      this.outerVisible = true;
      this.cancelone = true;
      this.EditDialog = 2;
    },
    selectOrder(val){
      if(val==21){
        this.isO2O = true;
      }else{
        this.isO2O = false;
        this.shopName = '';
      }
    },
    MakeSure() {
      let that = this;
      let orderNos = [];
      if (this.cancelone) {
        orderNos.push({
          orderId: this.CurrentSelection.orderId,
          orderNo: this.CurrentSelection.orderNo,
          orderStatus: this.CurrentSelection.orderStatus
        });
      } else {
        this.multipleSelection.forEach(val => {
          orderNos.push({
            orderId: val.orderId,
            orderNo: val.orderNo,
            orderStatus: val.orderStatus
          });
        });
      }

      that.disabled = true;
      const options = {
        url: "distribution/B2cOrderInfoController/deleteOrders",
        method: "post",
        headers: { "Content-Type": "application/json" },
        data: {
          orderNos: orderNos,
          orderStatus: that.CurrentSelection.orderStatus
        }
      };
      axios(options)
        .then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
          that.cancelone = false;
          that.cancelShow = false;
          if (response.data.code == 200) {
            that.initdata();
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          that.outerVisible = false;
          that.cancelShow = false;
          that.disabled = false;
          that.cancelone = false;
          http.handleHttpError(error, that);
        });
    },
    MakeCancel() {
      this.outerVisible = false;
      this.cancelone = false;
      this.cancelShow = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    EnterSelect() {
      if (this.orderStatus != "请选择") {
        this.CloseShow = true;
      }
    },
    LeaveSelect() {
      this.CloseShow = false;
    },
    ClearSelect() {
      this.orderStatus = "请选择";
    },
    EnterSelects() {
      if (this.orderFrom != "请选择") {
        this.CloseShows = true;
      }
    },
    ExportClick() {
      let that = this;
      let orderFrom = "";
      let orderStatus = "";
      if (that.orderFrom === "请选择") {
        orderFrom = "";
      } else {
        orderFrom = that.orderFrom;
      }
      if (that.orderStatus === "请选择") {
        orderStatus = "";
      } else {
        orderStatus = that.orderStatus;
      }
      const options = {
        url: "/distribution/B2cOrderInfoController/orderListExport",
        method: "get",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        params: {
          orderNo: that.orderNo,
          fuzzyRecom: that.fuzzyRecom,
          orderFrom: orderFrom,
          orderStatus: orderStatus,
          startTime: that.startTime,
          endTime: that.endTime
        }
      };
      axios(options)
        .then(function(response) {
          if (response.data.code !== undefined) {
            http.handleEorrorCode(response, that);
          } else {
            that.ExportClickSecond();
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    ExportClickSecond() {
      let that = this;
      let orderFrom = "";
      let orderStatus = "";
      if (that.orderFrom === "请选择") {
        orderFrom = "";
      } else {
        orderFrom = that.orderFrom;
      }
      if (that.orderStatus === "请选择") {
        orderStatus = "";
      } else {
        orderStatus = that.orderStatus;
      }
      const options = {
        url: "/distribution/B2cOrderInfoController/orderListExport",
        method: "get",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        params: {
          orderNo: that.orderNo,
          fuzzyRecom: that.fuzzyRecom,
          orderFrom: orderFrom,
          orderStatus: orderStatus,
          startTime: that.startTime,
          endTime: that.endTime
        },
        responseType: "blob"
      };
      axios(options)
        .then(function(response) {
          var filename = "订单列表" + new Date().getTime();
          let url = window.URL.createObjectURL(response.data);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", filename + ".xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    DeclareClick(item) {
      this.outerVisible = true;
      this.EditDialog = 3;
      this.CurrentSelection = item;
      this.ruleForm = {};
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
    },
    MakeSureEdit(formName) {
      let that = this;
      that.disabled = true;
      const options = {
        url: "distribution/B2cDeclareCustomsController/declareType",
        method: "post",
        headers: { "Content-Type": "application/json" },
        data: {
          payType: that.CurrentSelection.payType,
          orderNo: that.CurrentSelection.orderNo,
          recom: that.CurrentSelection.recom
        }
      };
      axios(options)
        .then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
          if (response.data.code == 200) {
            that.initdata();
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    LeaveSelects() {
      this.CloseShows = false;
    },
    ClearSelects() {
      this.orderFrom = "请选择";
    },
    DetailClick(row) {
      let searchContent = {};
      searchContent.orderNo = this.orderNo;
      searchContent.fuzzyRecom = this.fuzzyRecom;
      searchContent.TimeValue = this.TimeValue;
      searchContent.orderFrom = this.orderFrom;
      searchContent.orderStatus = this.orderStatus;
      this.$router.push({ path: "/orderdetail" });
      localStorage.setItem(
        "goodlist",
        JSON.stringify({
          row: row,
          pageNo: this.pageindex,
          pageSize: this.pageSize,
          searchContent: searchContent
        })
      );
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    SearchClick() {
      this.pageindex = 1;
      this.initdata();
    },
    ChangePicker() {
      if (this.TimeValue !== null) {
        this.startTime = this.FormatAllDate(this.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.TimeValue[1]);
      } else if (this.TimeValue === null) {
        this.startTime = "";
        this.endTime = "";
      }
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
    FormatSpecialDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() + seperator1 + month + seperator1 + strDate;

      return currentdate;
    },
    initdata() {
      let that = this;
      let orderFrom = "";
      let orderStatus = "";
      if (that.orderFrom === "请选择") {
        orderFrom = "";
      } else {
        orderFrom = that.orderFrom;
      }
      if (that.orderStatus === "请选择") {
        orderStatus = "";
      } else {
        orderStatus = that.orderStatus;
      }
      const options = {
        url: "distribution/B2cOrderInfoController/queryGoodsOrders",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          orderNo: that.orderNo,
          fuzzyRecom: that.fuzzyRecom,
          orderFrom: orderFrom,
          orderStatus: orderStatus,
          startTime: that.startTime,
          endTime: that.endTime,
          shopName: that.shopName,
          size: that.pageSize,
          current: that.pageindex
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.totalCount = response.data.data.totalCount;
            that.cancelShow = false;
            for (var i in response.data.data.data) {
              if (
                response.data.data.data[i].orderStatus === 1 ||
                response.data.data.data[i].orderStatus === 2 ||
                response.data.data.data[i].orderStatus === 3 ||
                response.data.data.data[i].orderStatus === 4
              ) {
                response.data.data.data[i].canceldisabled = false;
              } else {
                response.data.data.data[i].canceldisabled = true;
              }
              response.data.data.data[i].ordernumber =
                Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
              if (response.data.data.data[i].buyerTime !== null) {
                response.data.data.data[i].buyertime = that.FormatAllDate(
                  response.data.data.data[i].buyerTime
                );
              } else {
                response.data.data.data[i].buyertime = "";
              }

              if (
                response.data.data.data[i].orderStatus === 3 ||
                response.data.data.data[i].orderStatus === 4 ||
                response.data.data.data[i].orderStatus === 5
              ) {
                response.data.data.data[i].declaredisabled = false;
              } else {
                response.data.data.data[i].declaredisabled = true;
              }
              switch (response.data.data.data[i].orderStatus) {
                case 0:
                  response.data.data.data[i].orderstatus = "取消订单";
                  break;
                case 1:
                  response.data.data.data[i].orderstatus = "购物车";
                  break;
                case 2:
                  response.data.data.data[i].orderstatus = "已提交，未支付";
                  break;
                case 3:
                  response.data.data.data[i].orderstatus = "已支付";
                  break;
                case 4:
                  response.data.data.data[i].orderstatus = "拦截";
                  break;
                case 5:
                  response.data.data.data[i].orderstatus =
                    "审核放行，流转到中台";
                  break;
                case 6:
                  response.data.data.data[i].orderstatus = "已发货";
                  break;
                case 7:
                  response.data.data.data[i].orderstatus = "已收货";
                  break;
                case 8:
                  response.data.data.data[i].orderstatus = "交易成功";
                  break;
                case 9:
                  response.data.data.data[i].orderstatus = "售后";
                  break;
                case 10:
                  response.data.data.data[i].orderstatus = "退货";
                  break;
                case 11:
                  response.data.data.data[i].orderstatus = "退款";
                  break;
                case 12:
                  response.data.data.data[i].orderstatus = "换货";
                  break;
                case 13:
                  response.data.data.data[i].orderstatus = "交易关闭";
              }
            }

            that.UserManagementList = response.data.data.data;
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth {
  width: 202px;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderManage/OrderListServiceProvider.vue